// local storage keys
export const ACCESS_TOKEN_KEY = "accessToken";
export const HIDE_ANNOUNCEMENT_KEY = "hideAnnouncement";

// footer contact details
export const CONTACT_EMAIL = "gestione.tennistrebaseleghe@gmail.com";
export const CONTACT_PHONE = "389 5194241";
export const CONTACT_WEB = "www.tennistrebaseleghe.it";

// users
export const PASSWORD_MIN_LENGTH = 6;
